import gql from 'graphql-tag';

export default gql`
  mutation archiveRejectedOffer($id: Int!, $comments: String!) {
    archiveRejectedOffer(id: $id, comments: $comments)
  }
`;
